// latest: zhangmyh 2017-8-17 3:19 PM
/* global ko */

import './index.less'

export default function (params) {
  const questionUrl = '../questionsAnswers/index.zh_CN.html?questionTypeId='
  let hidable = ko.observable((params.visible))
  let _list = params.list
  let _typeid = params.typeId
  this.data = _list
  // _list = (hidable) ? [] : _list

  this.hidable = hidable
  this.url = ko.computed(function () {
    let typeid
    if (typeof _typeid == 'function') {
      typeid = _typeid()
    } else {
      typeid = _typeid
    }
    return questionUrl + typeid + '&questionId='
  })
  this.list = ko.computed(function () {
    if (hidable()) {
      return []
    }
    let list
    if (typeof _list == 'function') {
      list = _list()
    } else {
      list = _list
    }
    return list
  })
  // this.list = ko.observableArray(_list)
  this.toggle = function () {
    this.hidable(!this.hidable())
    /* let _hidable = !this.visible()
    if (_hidable) {
      this.list(this.data)
    } else {
      this.list([])
    }
    this.visible(_hidable) */
  }
}



// WEBPACK FOOTER //
// ./src/components/qanda-tips/index.js